// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"96db44db","477":"b204389b","505":"ffc4c620","679":"96db44db"}[chunkId] + ".chunk.css";
};